import { PhoneCall, Sparkles, Mail, Video, RefreshCw, Users } from 'lucide-react';
import type { NicheConfig } from './types';

export const hvacConfig: NicheConfig = {
  slug: 'hvac',
  niche: 'HVAC',
  meta: {
    title: 'Systemy AI dla firm HVAC w Trójmieście - DAIEN',
    description: 'Voicebot 24/7, paid funnels, outbound dla firm klimatyzacja / pompy / rekuperacja w Gdańsku, Gdyni i Sopocie. Mniej straconych zleceń, więcej zamówień. Bez zatrudniania.',
  },
  hero: {
    eyebrow: 'Trójmiasto · HVAC',
    title: 'Mniej straconych zleceń. Więcej zamówień.',
    titleAccent: 'Bez zatrudniania.',
    subtitle: 'Systemy AI dla firm HVAC: voicebot 24/7, paid funnels, outbound. Wdrażam dokładnie to czego sam używam w mojej firmie.',
    vslEmbedUrl: '',
    ctaLabel: 'Umów 30-min rozmowę',
    ctaHref: '#booking',
  },
  services: {
    sectionEyebrow: 'Co przedstawię na naszej rozmowie',
    sectionTitle: 'Sześć systemów które wdrażam u klientów HVAC',
    items: [
      {
        icon: PhoneCall,
        title: 'Recepcjonista wirtualny 24/7',
        description: 'Odbiera telefon w niecałą minutę. Umawia wizytę, transferuje pilne, nie traci leadu. Średnio 4 zlecenia miesięcznie odzyskane = 60-180 tys. PLN rocznie.',
        image: '/images/hvac/reception.webp',
      },
      {
        icon: Sparkles,
        title: 'Reklamy płatne z AI',
        description: 'Reklamy Meta i Google prowadzą do quizu kwalifikacyjnego, AI ocenia lead, AI bookuje wizytę. Mierzalny ROI. Klient HVAC już wydaje na ads, ale leakuje 70-80% leadów.',
        image: '/images/hvac/ads.webp',
      },
      {
        icon: Mail,
        title: 'Pozyskiwanie klientów B2B',
        description: 'Cold email, LinkedIn i telefon do biurowców, hoteli i deweloperów w Trójmieście. 100-500 firm dziennie. AI personalizuje, AI odpisuje, Ty dostajesz tylko hot leady.',
        image: '/images/hvac/b2b.webp',
      },
      {
        icon: Video,
        title: 'Generator kreacji wideo',
        description: 'Reels, shorts i kreacje reklamowe produkowane przez AI. Świeże warianty co 1-2 tygodnie. Koniec wypalania się jednym filmem przez miesiąc.',
        image: '/images/hvac/video.webp',
      },
      {
        icon: RefreshCw,
        title: 'Abonamenty serwisowe',
        description: 'Platforma abonamentowa dla Twojej bazy klientów. Ja buduję, Ty bierzesz 100% przychodów. Powtarzalne 200-500 PLN miesięcznie na klienta.',
        image: '/images/hvac/maintenance.webp',
      },
      {
        icon: Users,
        title: 'Program poleceń',
        description: 'Kod, SMS i landing pod polecenia. Twoi lojalni klienci sami przyprowadzają znajomych z sąsiedztwa. Auto-wypłata prowizji, zero ręcznej obsługi.',
        image: '/images/hvac/referral.webp',
      },
    ],
  },
  whyMe: {
    sectionEyebrow: 'Dlaczego ja',
    sectionTitle: 'Sam używam AIOS. To nie demo, to produkcja.',
    body: 'Prowadzę DAIEN z Trójmiasta i każdy system, który u Ciebie wdrożę, najpierw chodzi u mnie. Voicebot odbiera moje telefony. Outbound generuje moje leady. Content system kręci moje reklamy. Jeśli coś nie działa, widzę to pierwszy. Klienci tacy jak Kognita czy OZE Growth dostają systemy zwalidowane na realnej firmie, nie demo z konferencji.',
    points: [
      {
        title: 'Lokalny w Trójmieście',
        description: 'Znam rynek HVAC w Gdańsku, Gdyni i Sopocie. Nie sprzedaję z Warszawy slajdami w Google Meet.',
      },
      {
        title: 'Testowane na żywo',
        description: 'Każdy system najpierw odpalam u siebie w DAIEN. U klienta wdrażam to co już sprawdzone.',
      },
      {
        title: 'Pełna transparentność',
        description: 'Pokażę dokładnie ile kosztuje setup, ile retainer, jaki realny ROI po 30 / 60 / 90 dniach.',
      },
      {
        title: 'Stack adekwatny',
        description: 'Retell.ai do voicebota, n8n / Trigger.dev do workflow, Supabase do CRM. Sprawdzone, nie eksperyment.',
      },
    ],
  },
  cta: {
    title: 'Porozmawiajmy 30 minut',
    description: 'Pokażę systemy, podyskutujemy o Twojej firmie, zaproponuję bundle. Bez sprzedaży na siłę.',
    bookingUrl: 'https://calendar.app.google/4V6jKtrVUtMihmoE9',
  },
  thankYou: {
    title: 'Dzięki! Zgłoszenie mam.',
    body: 'Oddzwonię w ciągu kilku minut. W międzyczasie obejrzyj krótkie wideo i wybierz konkretny termin w kalendarzu.',
    // Wklej embed URL VSL podziekowania (Mux / YouTube unlisted / Vimeo) gdy wideo bedzie nagrane.
    vslEmbedUrl: '',
  },
};
